import React, { FC, useState } from 'react'
import { Shared } from 'ui/shared'
import Grid from '@mui/material/Grid'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { Radio } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { Actions_Parkings } from 'redux/modules/parkings/Actions'

const data = [
  { id: 0, value: undefined, name: 'All' },
  { id: 1, value: true, name: 'Virtual' },
  { id: 2, value: false, name: 'Physical' },
]

export const ParkingShowListParkingTypeFilter: FC = () => {
  const { classes } = useStyles()
  const { t } = useTranslation(I18nModal.parkingShowListParkingTypeFilter)

  const dispatch = useDispatch()

  const filter = useSelector((state: TState) => state.parkings.filter)

  const [checkedValue, setCheckedValue] = useState<boolean | undefined>(filter.isVirtual)

  const handleItem = (value: boolean | undefined) => () => {
    setCheckedValue(value)
  }

  const onSubmit = () => {
    dispatch(
      Actions_Parkings.store.changeFilter({
        ...filter,
        isVirtual: checkedValue,
      }),
    )

    dispatch(Actions_Modals.store.hideModal())
  }

  const closeModal = () => {
    dispatch(Actions_Modals.store.hideModal())
  }

  return (
    <Shared.Card className={classes.card}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Shared.CardTitle title={t('title')} />
        </Grid>

        <Grid item xs={12}>
          <List className={classes.list}>
            {data.map((status) => {
              const labelId = `checkbox-list-label-${status.id}`
              return (
                <ListItem key={status.id} role={undefined} dense button onClick={handleItem(status.value)}>
                  <ListItemIcon>
                    <Radio
                      edge="start"
                      checked={status.value === checkedValue}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ 'aria-labelledby': labelId }}
                      color={'primary'}
                    />
                  </ListItemIcon>
                  <ListItemText
                    id={labelId}
                    primary={status.name || '-'}
                    classes={{ root: classes.listItemText }}
                    disableTypography
                  />
                </ListItem>
              )
            })}
          </List>
        </Grid>

        <Grid item xs={12}>
          <Shared.Button className={classes.cancel} color={'secondary'} title={t('cancel')} onClick={closeModal} />
          <Shared.Button title={t('submit')} onClick={onSubmit} />
        </Grid>
      </Grid>
    </Shared.Card>
  )
}

const useStyles = makeStyles()((theme) => ({
  card: {
    width: 375,
    overflowY: 'auto',
    maxHeight: '100%',
  },
  list: {
    overflow: 'auto',
    maxHeight: 300,
  },
  listItemText: {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    color: theme.typography.body1.color,
  },
  cancel: {
    margin: '0.875em 0',
  },
}))
